import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCheckEmailAndUpdateStatus } from '@/hooks/useConfirmation';

export default function Confirm() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(null);
  
  // Get token from URL params
  const token = searchParams.get('token');
  
  // Custom hook to handle email verification and status update
  const { isLoading, isError, isSuccess, error: verificationError } = useCheckEmailAndUpdateStatus(token);

  useEffect(() => {
    if (!token) {
      setError('No confirmation token provided');
      const timeout = setTimeout(() => navigate('/'), 3000);
      return () => clearTimeout(timeout);
    }
  }, [token, navigate]);

  useEffect(() => {
    if (isSuccess) {
      // Redirect to success page after successful confirmation
      navigate('/confirmation-success');
    }
  }, [isSuccess, navigate]);

  if (!token) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
        <div className="text-center">
          <p className="text-red-600 mb-4">No confirmation token provided</p>
          <p className="text-gray-500">Redirecting to homepage...</p>
        </div>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
        <div className="text-center">
          <p className="text-gray-600">Verifying your subscription...</p>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center p-4">
        <div className="text-center">
          <p className="text-red-600 mb-4">{verificationError || 'Failed to verify subscription'}</p>
          <button
            onClick={() => navigate('/')}
            className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-pink-600 hover:bg-pink-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pink-500"
          >
            Return to Homepage
          </button>
        </div>
      </div>
    );
  }

  return null; // Success case is handled by useEffect redirect
}